"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.eventBus = {};
        this.handleMap = {};
    }
    /** 制造一个事件 */
    EventBus.prototype.emit = function (event, data) {
        var _this = this;
        if (this.eventBus[event]) {
            Object.keys(this.eventBus[event]).forEach(function (handleId) {
                _this.eventBus[event][handleId](data);
            });
        }
    };
    /** 取消一个订阅，如果传入句柄则取消某一个订阅 */
    EventBus.prototype.off = function (eventOrHandleId) {
        if (this.eventBus[eventOrHandleId]) {
            delete this.eventBus[eventOrHandleId];
        }
        else {
            var event = this.handleMap[eventOrHandleId];
            if (event) {
                delete this.eventBus[event][eventOrHandleId];
                delete this.handleMap[eventOrHandleId];
            }
        }
    };
    EventBus.prototype.on = function (event, callback) {
        if (!this.eventBus[event]) {
            this.eventBus[event] = {};
        }
        var handleId = (0, uniqueId_1.default)();
        this.eventBus[event][handleId] = callback;
        this.handleMap[handleId] = event;
        return handleId;
    };
    return EventBus;
}());
exports.EventBus = EventBus;
